import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-unauthorised',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './unauthorised.component.html',
  styleUrls: ['./unauthorised.component.scss']
})
export class UnauthorisedComponent {
  constructor(private router: Router) {}

  goBack(): void {
    this.router.navigate(['/overview']);
  }
}
